import React, { Component } from 'react';

class Notfound extends Component {
	render() {
		return (
			<div className="container">
				<h2>Not Found</h2>
				<img
					src="https://i.pinimg.com/originals/dc/59/3b/dc593ba12d61fe15aec1a5b2e9f6431d.gif"
					alt="Nick Young confused"
				/>
			</div>
		);
	}
}

export default Notfound;
